import type { FieldValues, Path, UseFormSetError } from "react-hook-form";
import { ApiError } from "./api";

type LaravelValidationErrorBody = {
  message?: string;
  errors?: Record<string, string[]>;
};

export function getLaravelValidationErrors(err: unknown): Record<string, string[]> | null {
  const apiErr = err as ApiError & { data?: unknown };
  if (!apiErr || typeof apiErr !== "object") return null;
  if (!("code" in apiErr) || typeof apiErr.code !== "string") return null;

  // requestJson uses `HTTP_${status}` when backend doesn't provide `code`.
  if (apiErr.code !== "HTTP_422") return null;

  const body = (apiErr.data as any)?.raw as LaravelValidationErrorBody | undefined;
  const errors = body?.errors;
  if (!errors || typeof errors !== "object") return null;
  return errors;
}

export function applyLaravelValidationErrors<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
  errors: Record<string, string[]>,
) {
  for (const [field, msgs] of Object.entries(errors)) {
    const msg = Array.isArray(msgs) ? msgs[0] : undefined;
    if (!msg) continue;
    setError(field as Path<TFieldValues>, { type: "server", message: msg });
  }
}

export function getErrorMessage(err: unknown, fallback: string) {
  if (err instanceof Error && err.message) return err.message;
  const anyErr = err as { message?: string };
  return anyErr?.message ?? fallback;
}

